export const preventWheel = element => {
    document.getElementById(element).blur()
} 